import { config } from 'client/hooks/config';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

export function useListSessions(userId: string) {
    const { key, path } = config.sessions.list(userId);

    const result = useQuery([key], () => Api.get({ path }));

    return {
        sessions: result.data ?? [],
        isLoading: result.isLoading,
        isFetching: result.isFetching,
    };
}
